import 'zingchart/es6';
import Vue from 'vue'
import zingchartVue from 'zingchart-vue';
import VueRouter from 'vue-router'

Vue.component('zingchart', zingchartVue)
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/sales/:db/:day",
    name: "Sales",
    component: () => import("../views/Sales.vue"),
  },
  {
    path: "/detail-sales/:db/:type_bill/:customer_type/:day",
    name: "DetailSales",
    component: () => import("../views/DetailSales.vue"),
  },
  {
    path: "/search-for-sales",
    name: "SearchForSales",
    component: () => import("../views/SearchForSales")
  },
  {
    path: "/search-for-sales-detail",
    name: "SearchForSalesDetail",
    component: () => import("../views/SearchForSalesDetail")
  },
  {
    path: "/payment",
    name: "PayDebt",
    component: () => import("../views/PayDebt")
  },
  {
    path: "/showpoint",
    name: "ShowPoint",
    component: () => import("../views/ShowPoint")
  },
  {
    path: "/menu",
    name: "Menu",
    component: () => import("../views/Menu")
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
